<template>
  <svg viewBox="0 0 111 110" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="54.4553"
      y="90.4055"
      width="16.461"
      height="16.461"
      rx="0.7316"
      transform="rotate(180 54.4553 90.4055)"
      fill="#9B0806"
    />
    <rect
      x="51.7119"
      y="14.502"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 51.7119 14.502)"
      fill="#FFD3D3"
    />
    <rect
      x="89.2063"
      y="88.5764"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.2063 88.5764)"
      fill="#FFD3D3"
    />
    <rect
      x="88.2917"
      y="14.502"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.2917 14.502)"
      fill="#FFD3D3"
    />
    <rect
      x="53.5408"
      y="71.201"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 53.5408 71.201)"
      fill="#EB8583"
    />
    <rect
      x="89.2063"
      y="70.2865"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.2063 70.2865)"
      fill="#EB8583"
    />
    <rect
      x="15.1318"
      y="87.6619"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1318 87.6619)"
      fill="#FFD3D3"
    />
    <rect
      x="70.9165"
      y="88.5764"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.9165 88.5764)"
      fill="#EB8583"
    />
    <rect
      x="70.002"
      y="14.502"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 70.002 14.502)"
      fill="#FFD3D3"
    />
    <rect
      x="106.582"
      y="87.6619"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.582 87.6619)"
      fill="#FFD3D3"
    />
    <rect
      x="34.3364"
      y="88.5764"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.3364 88.5764)"
      fill="#FFD3D3"
    />
    <rect
      x="33.4219"
      y="14.502"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.4219 14.502)"
      fill="#FFD3D3"
    />
    <rect
      x="15.1318"
      y="69.372"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1318 69.372)"
      fill="#FFD3D3"
    />
    <rect
      x="71.8308"
      y="71.201"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 71.8308 71.201)"
      fill="#9B0806"
    />
    <rect
      x="106.582"
      y="69.372"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.582 69.372)"
      fill="#FFD3D3"
    />
    <rect
      x="35.2507"
      y="71.201"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 35.2507 71.201)"
      fill="#9B0806"
    />
    <rect
      x="15.1318"
      y="32.7919"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1318 32.7919)"
      fill="#FFD3D3"
    />
    <rect
      x="70.002"
      y="105.952"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 70.002 105.952)"
      fill="#FFD3D3"
    />
    <rect
      x="70.9165"
      y="33.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.9165 33.7064)"
      fill="#EB8583"
    />
    <rect
      x="106.582"
      y="32.7919"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.582 32.7919)"
      fill="#FFD3D3"
    />
    <rect
      x="33.4219"
      y="105.952"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.4219 105.952)"
      fill="#FFD3D3"
    />
    <rect
      x="34.3364"
      y="33.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.3364 33.7064)"
      fill="#FFD3D3"
    />
    <rect
      x="15.1318"
      y="51.082"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1318 51.082)"
      fill="#FFD3D3"
    />
    <rect
      x="71.8308"
      y="52.911"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 71.8308 52.911)"
      fill="#EB8583"
    />
    <rect
      x="34.3364"
      y="51.9965"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.3364 51.9965)"
      fill="#EB8583"
    />
    <rect
      x="51.7119"
      y="105.952"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 51.7119 105.952)"
      fill="#FFD3D3"
    />
    <rect
      x="52.6265"
      y="33.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.6265 33.7064)"
      fill="#EB8583"
    />
    <rect
      x="88.2917"
      y="105.952"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.2917 105.952)"
      fill="#FFD3D3"
    />
    <rect
      x="89.2063"
      y="33.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.2063 33.7064)"
      fill="#FFD3D3"
    />
    <rect
      x="53.5408"
      y="52.911"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 53.5408 52.911)"
      fill="#EB8583"
    />
    <rect
      x="89.2063"
      y="51.9965"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.2063 51.9965)"
      fill="#9B0806"
    />
    <rect
      x="106.582"
      y="51.082"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.582 51.082)"
      fill="#FFD3D3"
    />
  </svg>
</template>